import React from 'react';
import MeetingItem from '../../cards/MeetingItem';
import './DashboardMeetingsView.css';

const DashboardMeetingsView: React.FC = () => {
  // Dummy data for meetings
  const meetings = [
    {
      title: 'Q4 Strategy Review',
      time: '10:00 AM',
      date: '2025-10-25',
      tag: 'Committee' as const,
      location: 'Microsoft Teams',
      attendeesCount: 12,
      inProgress: true
    },
    {
      title: 'Board of Directors Meeting',
      time: '2:30 PM',
      date: '2025-10-28',
      tag: 'Special' as const,
      location: 'Executive Boardroom',
      attendeesCount: 8,
      inProgress: false
    },
    {
      title: 'Weekly Team Sync',
      time: '9:00 AM',
      date: '2025-10-20',
      tag: 'Regular' as const,
      location: 'Conference Room A',
      attendeesCount: 15,
      inProgress: false
    }
  ];

  return (
    <main className="dashboard-content">
      <header className="dashboard-header">
        <div className="header-top">
          <div className="breadcrumb">
            <div style={{ display: 'flex' }}>
              <h1 className="main-title">
                Meetings
              </h1>
            </div>
          </div>
        </div>
        <section className="meetings-container">
          <div className="meeting-list">
            {meetings.map((meeting, index) => (
              <MeetingItem
                key={index}
                title={meeting.title}
                time={meeting.time}
                date={meeting.date}
                tag={meeting.tag}
                location={meeting.location}
                attendeesCount={meeting.attendeesCount}
                inProgress={meeting.inProgress}
              />
            ))}
          </div>
        </section>
      </header>
   </main>
  );
};

export default DashboardMeetingsView;
